"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var constant_1 = require("../constant");
var utils_1 = require("../utils");
var AbstactImage = (function () {
    function AbstactImage(url, props) {
        this.imageUrl = url;
        this.props = props;
        this.compatibleImageUrl = this.compatibleQiniuAndGeneralImage(this.imageUrl, this.props.qnParams || {}, this.props.online);
    }
    AbstactImage.prototype.transferQiniuHost = function (url) {
        if (!this.props.online) {
            return url;
        }
        var qiniuHost = "i.ezbuy.sg";
        var qiniuChinaHost = "o3pkb6kbz.qnssl.com";
        return url.replace(qiniuChinaHost, qiniuHost);
    };
    AbstactImage.prototype.stringifyQiniuUrl = function (mode, params) {
        if (mode === void 0) { mode = 2; }
        var queryFields = ["w", "h", "q", "format", "interlace", "ignore-error"];
        var searchStr = "imageView2/" + mode;
        queryFields.forEach(function (f) {
            var v = params[f];
            if (v) {
                searchStr += "/" + f + "/" + v;
            }
        });
        return searchStr;
    };
    AbstactImage.prototype.compatibleQiniuAndGeneralImage = function (imageUrl, options, online) {
        var qiniuProURL = "//i.ezbuy.sg/";
        var qiniuProURLI2 = "//i2.ezbuy.sg";
        var qiniuUATURL = "//7xiata.com1.z0.glb.clouddn.com/";
        var qiniuProURL2 = "//7xiuv9.com5.z0.glb.clouddn.com/";
        var QUALITY = 90;
        var params = typeof options === "string" ? options : __assign({}, options);
        var search = "";
        if (/^data:image/.test(imageUrl)) {
            return imageUrl;
        }
        if (typeof params === "string") {
            search = "?" + params;
        }
        else if (typeof params === "object") {
            var size = params.size, w = params.w, h = params.h, imageslim = params.imageslim;
            if (imageslim === true) {
                search = "?imageslim";
            }
            else {
                var sParams = {
                    q: QUALITY
                };
                var ratio = this.props.keepSize ? 1 : constant_1.DevicePixelRatio;
                if (w) {
                    sParams = __assign(__assign({}, sParams), { w: w && Math.round(w * ratio) });
                }
                if (h) {
                    sParams = __assign(__assign({}, sParams), { h: h && Math.round(h * ratio) });
                }
                if (size) {
                    sParams.w = Math.round(size * ratio);
                    sParams.h = Math.round(size * ratio);
                }
                if (utils_1.isSupportWebP()) {
                    sParams.format = "webp";
                }
                search = "?" + this.stringifyQiniuUrl(2, sParams);
            }
        }
        if (/^(?:https?\:)?\/\//.test(imageUrl)) {
            var thin = [
                qiniuProURL,
                qiniuUATURL,
                qiniuProURLI2,
                qiniuProURL2
            ].some(function (url) { return imageUrl.indexOf(url) !== -1; });
            if (thin && imageUrl.indexOf("?") === -1) {
                return this.transferQiniuHost("" + imageUrl + search);
            }
            return this.transferQiniuHost(imageUrl);
        }
        var qiniuDomain = qiniuProURL;
        if (!online) {
            qiniuDomain = qiniuUATURL;
        }
        return this.transferQiniuHost("" + qiniuDomain + imageUrl + search);
    };
    return AbstactImage;
}());
exports.default = AbstactImage;
